<div class="flex-fill w-100" id="card-state" style="min-height: calc(100vh - 110px);">
  <div class="card-header pt-0">
    <!--BODY PAGE-->
    <div class="">
      <!--<h1 *ngIf="splOperativeMode === 2">{{"splDtitle" | translate}}</h1>
      <h1 *ngIf="splOperativeMode === 1">{{"multiDTitle" | translate}}</h1>-->
      <div class="card-body" *ngIf="loading" style="min-height: calc(100vh - 160px);">
        <div class="d-flex justify-content-center align-items-center h-100">
          <div class="spinner-grow text-primary" style="width: 4rem; height: 4rem;" role="status">
            <span class="sr-only">{{"loading" | translate}}...</span>
          </div>
        </div>
      </div>

      <div *ngIf="!loading" >
        <div class="row pt-3 spl-inst-header">
          <!-- Installation -->
          <div class="col-12 col-md-12 col-lg-12 col-xl-12 col-xxl-6 mb-2">
            <div class="card-spl-body p-4">
              <div class="row">
                <div class="col-6 align-content-center d-flex align-items-center">
                  <h3 class="my-h3">{{"installation" | translate}}</h3>
                  <span class="ms-2 badge-pill badge-solar" *ngIf="splDataObject.totalPower<0">{{"Vertido solar" | translate}}</span>
                  <span class="ms-2 badge-pill badge-disabled" *ngIf="splDataObject.status == 1">{{"splStatusOverload" | translate}}</span>
                  <span class="ms-2 badge-pill badge-warning" *ngIf="splDataObject.status == 2">{{"splStatusRecover" | translate}}</span>
                </div>
                <div class="col-6 text-end">
                  <span class="text-lg" [ngClass]="splDataObject.status==1?'textOverload':splDataObject.status==2?'textRecover':splDataObject.totalPower>=0?'text-installation':'text-solar'">{{splDataObject.totalPower}} kW</span>
                  <span class="text-xs-grey"> / {{splDataObject.limitPower}} kW</span>
                </div>
              </div>
              <!-- BAR -->
              <div class="row align-items-center mt-2">
                <div class="col-12">
                  <ngb-progressbar class="progressInstallation" [value]="splDataObject.relOverload" [max]="1" [animated]="true" [ngClass]="{'progressOverload': splDataObject.status == 1, 'progressRecover': splDataObject.status == 2}">
                    <div>
                      <span class="">{{ formatOverloadPercent(splDataObject.relOverload) }} %</span>
                    </div>
                  </ngb-progressbar>
                </div>
              </div>
              <!-- DONUTS -->
              <div class="row justify-space-between align-items-center mt-3 ps-2 pe-2">
                <div class="col-4 col-sm-4 col-md-4 col-xl-4 text-center p-0" *ngFor="let gauge of splDataObject.gauge">
                  <div class="d-flex text-start">
                    <div>
                      <canvas class="ring-outside" height="80" width="80" id={{gauge.id}}></canvas>
                      <h3 class="ring-phase-text">{{gauge.phase}}</h3>
                    </div>
                    <div class="row align-content-center pl-2">
                      <strong class="text-installation" style="font-size: 20px;"
                      [ngClass]="{'textOverload': gauge.totalCurrent*0.23 > gauge.limitPowerByPhase, 'text-solar': gauge.totalPowerByPhase < 0}"
                      >{{ formatPhaseKw(gauge.totalPowerByPhase) }} kW</strong>
                      <span class="text-xs-grey"> / {{ formatPhaseKw(gauge.limitPowerByPhase) }} kW</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Linea de cargadires -->
          <div class="col-12 col-md-12 col-lg-12 col-xl-12 col-xxl-6 mb-3">
            <div class="card-spl-body p-4">
              <div class="row">
                <div class="col-6 align-content-center d-flex align-items-center">
                  <h3 class="my-h3">{{"chargerLine" | translate}}</h3>
                  <span class="ms-2 badge-pill badge-disabled" *ngIf="splDataObject2.relChgLineOverload > 1">{{"splStatusOverload" | translate}}</span>
                </div>
                <div class="col-6 text-end">
                  <span class="text-lg" [ngClass]="splDataObject2.relChgLineOverload > 1?'textOverload':'text-chargerLine'">{{splDataObject2.splEvsePower}} kW</span>
                  <span class="text-xs-grey"> / {{splDataObject2.splLimitPower}} kW</span>
                </div>
              </div>
              <!-- BAR -->
              <div class="row align-items-center mt-2">
                <div class="col-12">
                  <ngb-progressbar class="progressChargerLine" [value]="splDataObject2.relChgLineOverload" [max]="1" [animated]="true" [ngClass]="{'progressOverload': splDataObject2.relChgLineOverload > 1}">
                    <div>
                      <span class="">{{(splDataObject2.relChgLineOverload*100).toFixed(0)}} %</span>
                    </div>
                  </ngb-progressbar>
                </div>
              </div>
              <!-- DONUTS -->
              <div class="row justify-space-between align-items-center mt-3 ps-2 pe-2">
                <div class="col-4 col-sm-4 col-md-4 col-xl-4 text-center p-0" *ngFor="let gauge of splDataObject2.gauge">
                  <div class="d-flex text-start">
                    <div>
                      <canvas class="ring-outside" height="80" width="80" id={{gauge.id}}></canvas>
                      <h3 class="ring-phase-text">{{gauge.phase}}</h3>
                    </div>
                    <div class="row align-content-center ps-2">
                      <strong class="text-chargerLine" style="font-size: 20px;" [ngClass]="{'textOverload': gauge.splEvsePowerByPhase > gauge.splLimitPowerByPhase}">{{(gauge.splEvsePowerByPhase/1000).toFixed(2)}} kW</strong>
                      <span class="text-xs-grey"> / {{(gauge.splLimitPowerByPhase/1000).toFixed(2)}} kW</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- DEVICES -->
        <div class="d-flex flex-sm-wrap">
          <div *ngFor="let device of splDevices" class="card-spl col-12 col-sm-6 col-md-4 col-lg-6 col-xl-4 col-xxl-3">
            <div class="card-spl-body">
              <div class="card-spl-header ps-2" [ngClass]="device.disconnected ? 'card-spl-disconnected' : 'bg-primary'">
                <div class="d-flex justify-content-between">
                  <div class="d-flex align-items-baseline">
                    <a *ngIf="device.completeSerial" (click)="goToDevice(device.completeSerial)">
                      <span>{{device.name?device.name:(device.completeSerial?device.completeSerial:device.serial)}}</span>
                    </a>
                    <span class="subtitle-device" *ngIf="device.name">({{device.completeSerial?device.completeSerial:device.serial}})</span>
                    <span *ngIf="!device.completeSerial">{{device.serial}}</span>
                  </div>

                </div>
              </div>
              <div class="card-spl-content">
                <div *ngFor="let connector of device.connectors; let last = last">
                  <div class="ps-3 pe-3">
                    <div class="row mb-1">
                      <div class="col-9 d-flex">
                        <div>
                          <span class="card-spl-connector-tittle">Conector {{connector.connectorId}}</span>
                        </div>
                        <div class="ms-2">
                          <span class="badge-pill badge-disabled" *ngIf="connector.flags == 0">{{"splStatus0" | translate}}</span>
                          <span class="badge-pill badge-secondary" *ngIf="connector.flags == 1">{{"splStatus1" | translate}}</span>
                          <span class="badge-pill badge-success" *ngIf="connector.flags == 2">{{"splStatus2" | translate}}</span>
                        </div>
                      </div>
                      <div class="col-3 card-spl-pwm">
                        <span>{{formatNumber(connector.pwm)}} A</span>
                      </div>
                    </div>
                    <div class="d-flex">
                      <div class="col-4 card-spl-phase">
                        <div [ngClass]="connector.pbp[0] > 0 ? 'card-spl-phase-on' : 'card-spl-phase-off'" *ngIf="device.numPhases>1 || connector.phase[0]">
                          <span><span class="card-spl-phase-tittle">R:</span> {{formatNumber(connector.pbp[0]/1000)}} kW</span>
                          <ngb-progressbar class="progressBar progressBarRST" [value]="connector.pbp[0]" [max]="(connector.pwm*230)" [animated]="true"></ngb-progressbar>
                        </div>
                      </div>
                      <div class="col-4 card-spl-phase">
                        <div [ngClass]="connector.pbp[1] > 0 ? 'card-spl-phase-on' : 'card-spl-phase-off'"  *ngIf="device.numPhases>1 || connector.phase[1]">
                          <span><span class="card-spl-phase-tittle">S: </span>{{formatNumber(connector.pbp[1]/1000)}} kW</span>
                          <ngb-progressbar class="progressBar progressBarRST" [value]="connector.pbp[1]" [max]="(connector.pwm*230)" [animated]="true"></ngb-progressbar>
                        </div>
                      </div>
                      <div class="col-4 card-spl-phase">
                        <div [ngClass]="connector.pbp[2] > 0 ? 'card-spl-phase-on' : 'card-spl-phase-off'"  *ngIf="device.numPhases>1 || connector.phase[2]">
                          <span><span class="card-spl-phase-tittle">T: </span>{{formatNumber(connector.pbp[2]/1000)}} kW</span>
                          <ngb-progressbar class="progressBar progressBarRST" [value]="connector.pbp[2]" [max]="(connector.pwm*230)" [animated]="true"></ngb-progressbar>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="divider" *ngIf="!last"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
